import React from 'react';

export default function Broken() {
  return (
    <div>
      Something went wrong
    </div>
  );
}
